var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stackBar"},_vm._l((_vm.stacksData),function(data,device_name){return _c('div',{key:device_name},[_c('div',{staticClass:"row",staticStyle:{"padding":"0px 15px"}},[_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"px-0"},[_c('b-progress',{staticClass:"mb-0",style:({
              height:
                _vm.stacksSize == 'small'
                  ? '1.2rem'
                  : _vm.stacksSize == 'midle'
                  ? '2.2rem'
                  : _vm.stacksSize == 'package-small'
                  ? '1.2rem'
                  : _vm.stacksSize == 'package-midle'
                  ? '2.2rem'
                  : _vm.stacksSize == 'package-normal'
                  ? '3rem'
                  : '3rem',
            }),attrs:{"max":_vm.stacksBarMaxValue}},_vm._l((data),function(item,key){return _c('b-progress-bar',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
                trigger: 'hover',
                title:
                  item.status != null
                    ? item.status == '待機' && item.alarmDetail != ''
                      ? ("狀態:" + (item.status) + "<br>待機原因:" + (item.alarmDetail) + "<br>開始時間:" + (item.startTime) + "<br>結束時間:" + (item.endTime))
                      : ("狀態:" + (item.status) + "<br>開始時間:" + (item.startTime) + "<br>結束時間:" + (item.endTime))
                    : 'no data',
                html: true,
                placement: 'bottom',
                variant:
                  item.status == '警報'
                    ? 'danger'
                    : item.status == '生產'
                    ? 'success'
                    : item.status == '短寸'
                    ? 'success'
                    : item.status == '待機'
                    ? 'warning'
                    : item.status == '調車'
                    ? 'primary'
                    : item.status == '維修'
                    ? 'lavender'
                    : item.status == '關機'
                    ? 'secondary'
                    : 'dark',
                offset: 0,
              }),expression:"{\n                trigger: 'hover',\n                title:\n                  item.status != null\n                    ? item.status == '待機' && item.alarmDetail != ''\n                      ? `狀態:${item.status}<br>待機原因:${item.alarmDetail}<br>開始時間:${item.startTime}<br>結束時間:${item.endTime}`\n                      : `狀態:${item.status}<br>開始時間:${item.startTime}<br>結束時間:${item.endTime}`\n                    : 'no data',\n                html: true,\n                placement: 'bottom',\n                variant:\n                  item.status == '警報'\n                    ? 'danger'\n                    : item.status == '生產'\n                    ? 'success'\n                    : item.status == '短寸'\n                    ? 'success'\n                    : item.status == '待機'\n                    ? 'warning'\n                    : item.status == '調車'\n                    ? 'primary'\n                    : item.status == '維修'\n                    ? 'lavender'\n                    : item.status == '關機'\n                    ? 'secondary'\n                    : 'dark',\n                offset: 0,\n              }"}],key:key,staticClass:"stacked-bar",class:{
                'progress-bar-danger': item.status == '警報',
                'progress-bar-success': item.status == '生產',
                'progress-bar-len-short': item.status == '短寸',
                'progress-bar-maintain': item.status == '維修',
                'progress-bar-shunting': item.status == '調車',
                'progress-bar-warning': item.status == '待機',
                'progress-bar-secondary': item.status == '關機',
                'progress-bar-nodata': item.status == null,
              },attrs:{"value":item.duration_number}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between",style:({
            'font-size':
              _vm.stacksSize == 'small'
                ? '12px'
                : _vm.stacksSize == 'midle'
                ? '12px'
                : _vm.stacksSize == 'package-small'
                ? '12px'
                : _vm.stacksSize == 'package-midle'
                ? '12px'
                : _vm.stacksSize == 'package-normal'
                ? '18px'
                : '18px',
          })},[(data[0] != undefined)?[(_vm.stacksSize == 'normal')?_vm._l((_vm.stacksBarNumber_default),function(item,key){return _c('div',{key:key,class:_vm.stacksBarClass[key]},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}):(_vm.stacksSize == 'midle')?_vm._l((_vm.stacksBarNumber_default),function(item,key){return _c('div',{key:key,class:_vm.stacksBarClass[key],style:({
                  display:
                    _vm.stacksBarClass[key] == 'stacked-bar-time-24'
                      ? 'none'
                      : '',
                })},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}):(_vm.stacksSize == 'small')?_vm._l((_vm.stacksBarNumber_default),function(item,key){return _c('div',{key:key,class:_vm.stacksBarClass[key],style:({
                  display:
                    _vm.stacksBarClass[key] == 'stacked-bar-time-24'
                      ? 'none'
                      : '',
                })},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}):(_vm.stacksSize == 'package-small')?_vm._l((_vm.stacksBarNumber_package_default),function(item,key){return _c('div',{key:key,class:_vm.stacksBarClass_package_default[key]},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}):(_vm.stacksSize == 'package-midle')?_vm._l((_vm.stacksBarNumber_package_default),function(item,key){return _c('div',{key:key,class:_vm.stacksBarClass_package_default[key]},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}):(_vm.stacksSize == 'package-normal')?_vm._l((_vm.stacksBarNumber_package_default),function(item,key){return _c('div',{key:key,class:_vm.stacksBarClass_package_default[key]},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}):_vm._e()]:_vm._e()],2)])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56639aba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stackBar.vue
// module id = null
// module chunks = 